import {axiosInstanceWithToken}  from "../utils/Client";

export default class KPIService {
    static getKPIFilteredBYDate = (locationId, startData, endDate) => {
        let url = `/kpi/list/${locationId}/`;
        if(typeof startData !== "undefined" && typeof endDate !== "undefined" && (startData !== "Invalid date" && endDate !== "Invalid date")) {
            url = `/kpi/list/${locationId}/?start_date=${startData}&end_date=${endDate}`;
        }

        return axiosInstanceWithToken.get(url);
    };

    static getAllJobKPIs = (locationId) => {
        return axiosInstanceWithToken.get(`/kpi_planning/kpi/list/all/${locationId}/`);
    };

    static getKPICategoryData = () => {
        return axiosInstanceWithToken.get(`/kpi/category/`);
    };

    static getKPIAccordingToCategory = (
        locationId, categoryId, destinationId, 
        startData, endDate, name, code, allAgencyFilter
    ) => {
        if (!name) {
            name = '';
        } 
        if (!code) {
            code = '';
        } 
        if (!allAgencyFilter) {
            allAgencyFilter = 0;
        } 
        let url = `/kpi/category/list/${locationId}/${categoryId}/${destinationId}/?name=${name}&code=${code}&all_agency=${allAgencyFilter}`;
        if(
            startData && endDate &&
            typeof startData !== "undefined" && typeof endDate !== "undefined" 
            && (startData !== "Invalid date" && endDate !== "Invalid date")
        ) {
            url += `&start_date=${startData}&end_date=${endDate}`;
        }
        return axiosInstanceWithToken.get(url);
    };

    static getKPIData = (kpiId) => {
        return axiosInstanceWithToken.get(`/kpi/edit/${kpiId}/`);
    };

    static saveNewKPIData = (kpiData) => {
        return axiosInstanceWithToken.post("/kpi/add/", kpiData);
    };

    static saveExistingKPIData = (kpiData) => {
        return axiosInstanceWithToken.put(
            `/kpi/edit/${kpiData.id}/`,
            kpiData,
        );
    };

    static deleteKPIData = (selectedKPIId, locationList) => {
        let locationParam = '?';
        for (let i in locationList) {
            locationParam += `location_list=${locationList[i]}&`
        }
        return axiosInstanceWithToken.delete(
            `/kpi/edit/${selectedKPIId}/${locationParam}`
        );
    };

    static getKpiHeadingList = (selectedKPIId) => {
        return axiosInstanceWithToken.get(`/kpi/heading/${selectedKPIId}/`);
    };

    static saveNewKPIHeading = (kpiHeading, kpiId) => {
        return axiosInstanceWithToken.post(
            `/kpi/heading/${kpiId}/`,
            kpiHeading,
        );
    };

    static saveExistingKPIHeading = (kpiHeading) => {
        return axiosInstanceWithToken.put(
            `/kpi/heading/edit/${kpiHeading.id}/`,
            kpiHeading,
        );
    };

    static deleteKPIHeading = (kpiHeadingId) => {
        return axiosInstanceWithToken.delete(`/kpi/heading/edit/${kpiHeadingId}/`);
    };

    static getHeadingItemList = (selectedKPIHeadingId) => {
        return axiosInstanceWithToken.get(`/kpi/drop_down/${selectedKPIHeadingId}/`);
    };

    static saveNewHeadingItem = (kpiHeadingItem, selectedKPIHeadingId) => {
        return axiosInstanceWithToken.post(
            `/kpi/drop_down/${selectedKPIHeadingId}/`,
            kpiHeadingItem
        );
    };

    static saveExistingHeadingItem = (kpiHeadingItem) => {
        return axiosInstanceWithToken.put(
            `/kpi/drop_down/edit/${kpiHeadingItem.id}/`,
            kpiHeadingItem 
        );
    };

    static deleteHeadingItem = (itemId) => {
        return axiosInstanceWithToken.delete(`/kpi/drop_down/edit/${itemId}/`);
    };

    static isDeletionAllowed = (kpiId) => {
        return axiosInstanceWithToken.get(`/kpi/is_allowed_to_delete/${kpiId}/`);
    };

    static getDefinitionPDFContent = (
        agencyLocation, categoryId, destinationId, startData, endDate, name, code, allAgencyFilter
    ) => {
        let url = `/kpi/definition/report/${agencyLocation}/${categoryId}/${destinationId}/?name=${name}&code=${code}&all_agency=${allAgencyFilter}`;
        if(
            startData && endDate &&
            typeof startData !== "undefined" && typeof endDate !== "undefined" 
            && (startData !== "Invalid date" && endDate !== "Invalid date")
        ) {
            url += `&start_date=${startData}&end_date=${endDate}`;
        }
        return axiosInstanceWithToken.get(url);
    };

    static getHeadingPDFContent = (
        agencyLocation, categoryId, destinationId, startData, endDate, name, code
    ) => {
        let url = `/kpi/heading/report/${agencyLocation}/${categoryId}/${destinationId}/?name=${name}&code=${code}`;
        if(
            startData && endDate &&
            typeof startData !== "undefined" && typeof endDate !== "undefined" 
            && (startData !== "Invalid date" && endDate !== "Invalid date")
        ) {
            url += `&start_date=${startData}&end_date=${endDate}`;
        }
        return axiosInstanceWithToken.get(url);
    };

    static getActivityCodePDFContent = (
        agencyLocation, categoryId, destinationId, startData, endDate, name, code, allAgencyFilter
    ) => {
        let url = `/kpi/activity_code/report/${agencyLocation}/${categoryId}/${destinationId}/?name=${name}&code=${code}&all_agency=${allAgencyFilter}`;
        if(
            startData && endDate &&
            typeof startData !== "undefined" && typeof endDate !== "undefined" 
            && (startData !== "Invalid date" && endDate !== "Invalid date")
        ) {
            url += `&start_date=${startData}&end_date=${endDate}`;
        }
        return axiosInstanceWithToken.get(url);
    };

    static getKpiActivityCode = (kpiId) => {
        return axiosInstanceWithToken.get(`/kpi/activity_code/${kpiId}/` );
    };

    static setKpiActivityCode = (kpiId, activityCode) => {
        return axiosInstanceWithToken.put(
            `/kpi/activity_code/${kpiId}/`, activityCode
        );
    };

    static getDestinationCategories = () => {
        return axiosInstanceWithToken.get(`/kpi/destination/`);
    };

    static getAgencyProfileList = (agencyLocation) => {
        return axiosInstanceWithToken.get(`/kpi/agency_profile/${agencyLocation}/`);
    };

    static saveAgencyProfile = (data, agencyProfileId) => {
        return axiosInstanceWithToken.put(
            `/kpi/agency_profile/update/${agencyProfileId}/`, data
        );
    };

    static kpiDefinitionPDFforJobTitle = (selectedJobTitle) => {
        let url = `/kpi_planning/definition/report/${selectedJobTitle}/`;
        return axiosInstanceWithToken.get(url);
    };

    static kpiHeadingPDFforJobTitle = (selectedJobTitle) => {
        let url = `/kpi_planning/headings/report/${selectedJobTitle}/`;
        return axiosInstanceWithToken.get(url);
    };
}



// WEBPACK FOOTER //
// ./src/services/KPIService.js